import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Instagram } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative min-h-[50vh] flex items-end">
        <img src="https://images.pexels.com/photos/28941551/pexels-photo-28941551.jpeg" alt="Bindni heritage" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-maroon-deep/95 via-brand-maroon-deep/50 to-transparent" />
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-10 py-16 text-brand-ivory">
          <p className="label-tiny text-brand-gold hero-text-shadow">Our Story</p>
          <h1 className="font-serif-brand text-5xl lg:text-6xl mt-3 hero-text-shadow">Crafted with love. Worn every day.</h1>
        </div>
      </section>

      <section className="max-w-[900px] mx-auto px-6 py-20">
        {/* Vision */}
        <div className="border-l-2 border-brand-gold pl-6 mb-14" data-testid="vision-block">
          <p className="label-tiny text-brand-gold">Our Vision</p>
          <p className="font-serif-brand text-2xl lg:text-3xl text-brand-maroon mt-3 leading-tight italic">
            "Every Bindni deserves the beautiful experience of jewellery — curated with love by our core Rajasthani artisans."
          </p>
        </div>

        <p className="text-lg leading-relaxed text-brand-charcoal/90">
          Bindni Jewels was born in <span className="text-brand-maroon font-medium">2026</span> with a simple idea — that great jewellery shouldn't wait for a wedding. Whether you're a college grad heading to your first interview, a millennial styling a Sunday brunch, or a bride shopping for your sangeet, there should be a piece that feels like it was made for you.
        </p>
        <div className="gold-divider my-10" />
        <p className="text-lg leading-relaxed text-brand-charcoal/90">
          Every piece is handcrafted in Rajasthan by 4th-generation karigars, blending old-world techniques with a modern <span className="text-brand-maroon font-medium">anti-tarnish micron-gold plating</span> that keeps the shine alive through rain, workouts, and endless festivals.
        </p>
        <div className="gold-divider my-10" />
        <p className="text-lg leading-relaxed text-brand-charcoal/90">
          From daily hoops to bridal ensembles — we make jewellery you don't need to save for special occasions. Because every day you wear a Bindni piece <em>is</em> a special occasion.
        </p>

        <div className="mt-16 grid grid-cols-3 text-center gap-6 border-y border-brand-gold/25 py-10">
          <div><p className="font-serif-brand text-3xl text-brand-maroon">12,000+</p><p className="label-tiny text-brand-muted mt-2">Happy Customers</p></div>
          <div><p className="font-serif-brand text-3xl text-brand-maroon">4.9★</p><p className="label-tiny text-brand-muted mt-2">Avg Rating</p></div>
          <div><p className="font-serif-brand text-3xl text-brand-muted mt-2">450+</p><p className="label-tiny text-brand-muted mt-2">Cities Served</p></div>
        </div>

        <div className="text-center mt-16">
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/shop" className="btn-primary" data-testid="about-shop-cta">Discover Our Craft</Link>
            <a href="https://wa.me/c/917987780925" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-6 py-3 bg-[#25D366] text-white text-xs tracking-[0.2em] uppercase font-medium hover:brightness-110" data-testid="about-wa-catalog-cta"><MessageCircle size={14} /> Shop on WhatsApp</a>
            <a href="https://www.instagram.com/bindni_jewels" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-6 py-3 text-white text-xs tracking-[0.2em] uppercase font-medium hover:brightness-110" style={{ background: "linear-gradient(45deg, #F58529, #DD2A7B, #8134AF, #515BD4)" }} data-testid="about-ig-cta"><Instagram size={14} /> Shop on Instagram</a>
          </div>
        </div>
      </section>
    </div>
  );
}
